<script setup lang="ts">
import { type Emoji } from '#shared'

const { emoji } = defineProps<{ emoji: Emoji }>()

const emit = defineEmits<{ select: [emoji: Emoji] }>()

const onClick = () => {
  emit('select', emoji)
}
</script>

<template>
  <div :class="$style.root" tabindex="-1" role="button" :title="emoji.name" @click="onClick">
    {{ emoji.char }}
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  font-family: 'Noto Color Emoji', serif;
  font-weight: 400;
  font-style: normal;
  font-size: 25px;
  overflow: hidden;
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
}
</style>
